module.exports = __webpack_public_path__ + "static/AviaryAttorney2-97d26acf550f627c82b09b813c55ec78.webp";